<template>
  <div>
    <pre ref="preText" v-if="!overflow">{{text}}</pre>
    <p ref="pText" v-else>{{text}}</p>
  </div>
</template>

<script>
export default {
  name: "PreOrP",
  props: ["text"],
  data() {
    return {
      overflow: false
    };
  },
  created() {
    window.addEventListener("resize", this.onResize);
  },
  destroyed() {
    window.removeEventListener("resize", this.onResize);
  },
  methods: {
    onResize: async function() {
      this.overflow = false;
      let thiss = this;
      setTimeout(() => thiss.overflow = thiss.$refs.preText.clientWidth < thiss.$refs.preText.scrollWidth,0);
    }
  },
  mounted: function() {
    this.onResize();
  }
};
</script>

<style>
</style>